const doc = [({"en":({"js":({"admin":({"layout_bottom_bar":({"pagination":({"of_total":"of %{total}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;